import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useFanPublicationStore } from "%/stores/fan-publication-store";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";

export const useMyDigitalProductPurchaseFeedStore = defineSmartFeedPiniaStore("my-digital-product-purchase-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    tableFields: [
      { key: "productName", label: "Name" },
      { key: "datePurchased", label: "Date Purchased" },
      { key: "pricePaid", label: "Amount Paid" },
      { key: "productType", label: "Product Type" },
      { key: "downloadUrl", label: "" },
    ],
  }),
  getters: {
    // Lazy read: a state snapshot froze publicationId at 0 pre-seed.
    feedUrl() {
      return `/digital-product-purchase/publication/${useFanPublicationStore().publicationId}/purchases/smart-feed`;
    },
  },
});
